import React, { Component } from 'react';

import Menu from './Menu/menu';
import Footer from './Footer/Footer';
import Hero from '../Hub/hero/hero'
import DynamicPagePromos from '../Hub/dynamicPagePromos/dynamicPagePromos'
import VideoArticlePromos from '../Hub/videoArticlePromos/videoArticlePromos'
import Advert from './Advert/Advert'
import $ from 'jquery';
import IsNotDomestic from '../../helpers/IsNotDomestic';

import globalJSON from '../../data/global.json';
import hubJSON from '../../data/hub.json';

//style css
import classes from './App.module.scss';
const globalImages = require.context('../../images/components/Global', true, /.*\.(gif|png|jpe?g|svg)$/i);


class App extends Component {

	constructor(){

		super()

		window.scrollTo(0,0);

		this.pereviousScrollPercentage = 0;

		this.onScroll = this.onScroll.bind(this)
		window.addEventListener('scroll', this.onScroll)
		let progress25Tracked = false;
		let progress50Tracked = false;
		let progress75Tracked = false;
		let progress100Tracked = false;
		
		//Force external links to open in-app to avoid breaking user experience
		var eventHandler = function (event) {
			// Only run for iOS full screen apps
			if (('standalone' in window.navigator) && window.navigator.standalone) {
				// Only run if link is an anchor and points to the current page
				if ( event.target.tagName.toLowerCase() !== 'a' || event.target.hostname !== window.location.hostname || event.target.pathname !== window.location.pathname || !/#/.test(event.target.href) ) return;
		
				// Open link in same tab
				event.preventDefault();
				window.location = event.target.href;
			}
		}

		window.addEventListener('click', eventHandler, false);

		this.state = {
			windowSize: 'desktop'
		}

		
	}

	onScroll(){

		var s = this.getCurrentPosition()
		this.heightOfPage()

	}

	heightOfPage(){
	
		var $articleElement = $('div');
		var articleHeight =$articleElement.outerHeight(true);
		var viewPort= window.innerHeight;
		var percentage = ((this.getCurrentPosition() + viewPort) - $articleElement.position().top)/articleHeight * 100;
		var minMaxPercentage = Math.min(100, Math.max(this.pereviousScrollPercentage, percentage));

		// to do tracking checks
		if(minMaxPercentage >= 25){
			if(!this.progress25Tracked) {
				window.gtag('event', "viewed hub",{
				'event_category': globalJSON.tracking.ga_category,
				'event_label': "scroll 25% progress",
				'value':10
				});
				this.progress25Tracked = true;				
			}
		}

		if(minMaxPercentage >= 50){
			if(!this.progress50Tracked) {
				window.gtag('event', "viewed hub",{
				'event_category': globalJSON.tracking.ga_category,
				'event_label': "scroll 50% progress",
				'value':10
				});
				this.progress50Tracked = true;				
			}
		}
		
		if(minMaxPercentage >= 75){
			if(!this.progress75Tracked) {
				window.gtag('event', "viewed hub",{
				'event_category': globalJSON.tracking.ga_category,
				'event_label': "scroll 75% progress",
				'value':10
				});
				this.progress75Tracked = true;
			}
		}

		if(minMaxPercentage >= 100){
			if(!this.progress100Tracked) {
				window.gtag('event', "viewed hub",{
				'event_category': globalJSON.tracking.ga_category,
				'event_label': "scroll 100% progress",
				'value':10
				});
				this.progress100Tracked = true;					
			}
		}
			
		this.pereviousScrollPercentage= minMaxPercentage;

	}

	onLatestCtaInteraction(interactionData){

        var elmnt = document.getElementById("series_module__video_container");
        var main_menu = document.getElementById("main_menu");

        if(typeof(window.stop) !== "undefined"){
            //window.stop(true)
            window.scrollTo({top:elmnt.offsetTop - main_menu.offsetHeight, behavior:"smooth"});
        }else{
            window.scrollTo(0,(elmnt.offsetTop - main_menu.offsetHeight));
        }
		setTimeout(this.setState({episodeSelection:interactionData}), 2000)
		this.setState({episodeSelection:interactionData})
	}

	getCurrentPosition = () => {
		return Math.abs(( window.scrollY || document.body.scrollTop || document.documentElement.scrollTop));
	}
	
	componentDidUpdate(){

	}


	componentDidMount() {
		this.resize();
		window.onresize = this.resize.bind(this);
	}
	
	resize() {
		if (window.innerWidth < 768) {
			this.setState({windowSize: 'mobile'});
			
		} else if(window.innerWidth < 1200) {
			this.setState({windowSize: 'tablet'});
			
		} else {
			this.setState({windowSize: 'desktop'});
			
		}
		
	}
	
	render() {
		return (
				<div>
					
					<Menu globalImages={globalImages} />
					
					<div className={`App ${classes.App}`}>
						{/* <IsNotDomestic>
							<Advert column={hubJSON.advert.columns} content={hubJSON.advert} windowSize={this.props.windowSize}/>
						</IsNotDomestic> */}
						<Hero content={hubJSON.hero} windowSize={this.state.windowSize} />
						<DynamicPagePromos windowSize={this.state.windowSize} mytetsprop={"hello"}/> 
						{(
							hubJSON.videoArticlePromos ? 
								<VideoArticlePromos windowSize={this.state.windowSize} content={hubJSON.videoArticlePromos} /> 
							: 
								""
						)}
					</div>
	
					<Footer />
					
				</div>
		);
  	}
}

export default App;